import {
    ContentfulEntryContract,
    ContentfulEntryContractFields,
    ContentfulEntryFromContract,
} from './contracts';

export interface EulaContentFields extends ContentfulEntryContractFields {
    description?: string;
    description2?: string;
    description3?: string;
    version?: string;
}

export type EulaContentContract = ContentfulEntryContract<
    EulaContentFields,
    'eula'
>;

export type EulaContent = ContentfulEntryFromContract<EulaContentContract>;

export class Eula {
    private readonly contract: EulaContent;

    constructor(contract: EulaContent = {} as EulaContent) {
        this.contract = contract;
    }

    get description(): string {
        const desc1 = this.contract.fields?.description ?? '';
        const desc2 = this.contract.fields?.description2 ?? '';
        const desc3 = this.contract.fields?.description3 ?? '';

        return `${desc1}${desc2}${desc3}`;
    }

    get version(): string {
        return this.contract.fields.version ?? '';
    }
}
